import { createRouter, createWebHistory } from "vue-router";
import AdvancedView from "../views/AdvancedView.vue";
import AiOpsLab from "../views/AiOpsLab.vue";
import BuyVip from "../views/BuyVip.vue";
import ContactView from "../views/ContactView.vue";
import DemoPage from "../views/DemoPage.vue";
import DemoPage2 from "../views/DemoPage2.vue";
import DockerMap from "../views/specialized/DockerMap.vue";
import KubernetesMap from "../views/specialized/KubernetesMap.vue";
import FAQ from "../views/FAQ.vue";
import GoodOps from "../views/GoodOps.vue";
import HomeView from "../views/HomeView.vue";
import ITTerms from "../views/ITTerms.vue";
import LoginPage from "../views/LoginPage.vue";
import NotFound from "../views/NotFound.vue";
import OnlineContainer from "../views/OnlineContainer.vue";
// import OnlineDistros from "../views/OnlineDistros.vue";
import OnlineWindows from "../views/OnlineWindows.vue";
import MultiInstances from "../views/MultiInstances.vue";
import ManPages from "../views/ManPages.vue";
import OpsEngReading from "../views/OpsEngReading.vue";
import OpsInterview from "../views/OpsInterview.vue";
import OpsSecurity from "../views/OpsSecurity.vue";
import OpsTools from "../views/OpsTools.vue";
import PortalHome from "../views/PortalHome.vue";
import RegPage from "../views/RegPage.vue";
import ServerSelection from "../views/ServerSelection.vue";
import KnowledgeLibrary from "../views/KnowledgeLibrary.vue";
import KnowledgeDetail from "../views/KnowledgeDetail.vue";
import SupportTicket from "../views/SupportTicket.vue";
import TermView from "../views/TermView.vue";
import UserCenter from "../views/UserCenter.vue";
import UserPrivacy from "../views/UserPrivacy.vue";
import RechargePoints from "../views/RechargePoints.vue";
import PointsConsumption from "../views/PointsConsumption.vue";
import ResilienceLab from "../views/ResilienceLab.vue";
import ServiceStatus from "../views/ServiceStatus.vue";

const routes = [
  {
    path: "/docker",
    name: "docker",
    component: DockerMap,
  },
  {
    path: "/kubernetes",
    name: "kubernetes",
    component: KubernetesMap,
  },
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/term",
    name: "term",
    component: TermView,
  },
  {
    path: "/advanced/:taskId",
    name: "advanced",
    component: AdvancedView,
  },
  {
    path: "/terms",
    name: "terms",
    component: ITTerms,
  },
  {
    path: "/online-env",
    name: "online-env",
    component: MultiInstances,
  },
  {
    path: "/scenario-lab",
    name: "scenario-lab",
    component: AiOpsLab,
  },
  {
    path: "/resilience-lab",
    name: "resilience-lab",
    component: ResilienceLab,
  },
  {
    path: "/ai-ops-lab",
    redirect: "/scenario-lab",
  },
  {
    path: "/good-ops",
    name: "good-ops",
    component: GoodOps,
  },
  {
    path: "/ops-eng-reading",
    name: "ops-eng-reading",
    component: OpsEngReading,
  },
  {
    path: "/interview",
    name: "interview",
    component: OpsInterview,
  },
  {
    path: "/ops-security",
    name: "ops-security",
    component: OpsSecurity,
  },
  {
    path: "/faq",
    name: "faq",
    component: FAQ,
  },
  {
    path: "/man-pages",
    name: "man",
    component: ManPages,
  },
  {
    path: "/portal",
    name: "portal",
    component: PortalHome,
  },
  {
    path: "/topics",
    redirect: "/knowledge",
  },
  {
    path: "/knowledge",
    name: "knowledge",
    component: KnowledgeLibrary,
  },
  {
    path: "/knowledge/:slug",
    name: "knowledge-detail",
    component: KnowledgeDetail,
  },
  {
    path: "/recharge-points",
    name: "recharge-points",
    component: RechargePoints,
  },
  {
    path: "/points-consumption",
    name: "points-consumption",
    component: PointsConsumption,
  },
  {
    path: "/user-center",
    name: "user-center",
    component: UserCenter,
  },
  {
    path: "/support-ticket",
    name: "support-ticket",
    component: SupportTicket,
  },
  {
    path: "/buy-vip",
    name: "buy-vip",
    component: BuyVip,
  },
  {
    path: "/login",
    name: "login",
    component: LoginPage,
  },
  {
    path: "/ops-tools",
    name: "ops-tools",
    component: OpsTools,
  },
  {
    path: "/register",
    name: "register",
    component: RegPage,
  },
  {
    path: "/demo",
    name: "demo",
    component: DemoPage,
  },
  {
    path: "/demo2",
    name: "demo2",
    component: DemoPage2,
  },
  {
    path: "/nearby-site",
    name: "nearby-site",
    component: ServerSelection,
  },
  {
    path: "/online-windows",
    name: "online-windows",
    component: OnlineWindows,
  },
  {
    path: "/multi-instances",
    name: "multi-instances",
    component: MultiInstances,
  },
  {
    path: "/online-container",
    name: "online-container",
    component: OnlineContainer,
  },
  {
    path: "/privacy",
    name: "privacy",
    component: UserPrivacy,
  },
  {
    path: "/contact",
    name: "contact",
    component: ContactView,
  },
  {
    path: "/status",
    name: "status",
    component: ServiceStatus,
  },
  {
    path: "/:pathMatch(.*)*",
    name: "NotFound",
    component: NotFound,
  },
  {
    path: "/about",
    name: "about",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/AboutView.vue"),
  },
  {
    path: "/deploy-site",
    name: "deploy-site",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/DeployIt.vue"),
  },
  {
    path: "/about-us",
    name: "about-us",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/AboutView.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
